(() => {
    var linkElements = document.querySelectorAll('a');

    for(var i=0; i<linkElements.length; i++) {
        var hrefVal = linkElements[i].getAttribute('href');
        var queryVal = window.location.search;

        if(hrefVal) {
            if(hrefVal.indexOf('tel:') !== -1 || hrefVal.indexOf('mailto:') !== -1 || hrefVal.indexOf('#') !== -1) {
                //doNothing
            } else {
                hrefVal = hrefVal.includes('?') ? hrefVal + queryVal.replace('?', '&') : hrefVal + queryVal;
                linkElements[i].setAttribute('href', hrefVal);
            }
        }
    }
})();